import React from "react";
import { Text } from "react-form";

export default ({ label, ...rest }) => {
  return (
    <div className="field">
      <label className="label">{label}</label>
      <p className="control">
        <Text className="input" {...rest} />
      </p>
      {/* <p className={`help ${helpClass}`}>{helpMessage}</p> */}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/form-fields/InputText.js